import { render, staticRenderFns } from "./RequestsShow.vue?vue&type=template&id=125ed538&"
import script from "./RequestsShow.vue?vue&type=script&lang=js&"
export * from "./RequestsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports